/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Styled components for settings statistics
 *
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.3.1
 */

import styled from 'styled-components';

export const SettingsStatisticsContainerStyled = styled.div`
    padding: 24px 0 0 24px;
`;
